import { render } from "./Sitemap.pug?vue&type=template&id=00d8be2a&ts=true&lang=pug&external"
import script from "./Sitemap.ts?vue&type=script&lang=ts&external"
export * from "./Sitemap.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Sitemap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00d8be2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00d8be2a', __exports__)) {
    api.reload('00d8be2a', __exports__)
  }
  
  module.hot.accept("./Sitemap.pug?vue&type=template&id=00d8be2a&ts=true&lang=pug&external", () => {
    api.rerender('00d8be2a', render)
  })

}


export default __exports__